import React, { useRef, useEffect, useCallback } from "react";

function useOutsideAlerter(ref: RefObject<null>, setFunction: Function) {
  const handleClickOutside = useCallback((event:MouseEvent) => {
    // @ts-ignore: Object is possibly 'null'.
    if (ref && ref.current && !ref.current.contains(event.target)) {
      setFunction(false);
    }
  },[ref, setFunction]);

  useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
  }, [ref, handleClickOutside]);
}

export default function OutsideAlerter({setFunction, children}:OutsideAlerterProps) {
  const wrapperRef = useRef(null);

    useOutsideAlerter(wrapperRef, setFunction);

  return <div ref={wrapperRef} style={{display: "inline-flex"}}>{children}</div>;
}

interface OutsideAlerterProps{
  setFunction: Function;
  children: React.ReactElement;
}

interface RefObject<T> {
  readonly current: T | null
}